export const CARDOWNER_ROLE_ID = "97940af1-2786-4f67-b306-825f8b07db19";
export const REDEEM_IS_CUSTOM = "CUSTOM";
export const USER_SYSTEM = "system";
export const TENANT_SYSTEM = "00000000-0000-0000-0000-000000000000";
